// Icons libraries
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

import customIcons from "./customIconsVuetifyImport";

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: "mdi" || "fa",
    // Importing custom icons
    values: {
      ...customIcons
    }
  },
  theme: {
    themes: {
      light: {
        primary: "#104f55",
        secondary: "#dea70f",
        accent: "#00262c",
        error: "#ff5252",
        info: "#437b81",
        success: "#4CAF50",
        warning: "#FFC107"
      },
      dark: {
        primary: "#104f55",
        secondary: "#ffd600",
        accent: "#00262c",
        error: "#FF5252",
        info: "#437b81",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    },
    options: { variations: false }
  }
};
export default new Vuetify(opts);
